import type { TranslationDict } from '../en';

const ta: TranslationDict = {
  // ─── Header ───
  'header.buy': 'வாங்கு',
  'header.sell': 'விற்கு',

  // ─── SpendCard ───
  'spend.label': 'நீங்கள் செலவிடுகிறீர்கள்',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'நீங்கள் பெறுகிறீர்கள்',

  // ─── PaymentCard ───
  'payment.label': 'கட்டண முறை',
  'payment.select': 'தேர்ந்தெடு',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'இந்த ஜோடிக்கு கட்டண முறைகள் எதுவும் இல்லை',

  // ─── WalletCard ───
  'wallet.label': 'பெறும் வாலட் முகவரி',
  'wallet.placeholderBuy': 'உங்கள் பெறும் முகவரியை உள்ளிடவும்',
  'wallet.placeholderSell': 'உங்கள் அனுப்பும் முகவரியை உள்ளிடவும்',
  'wallet.validating': 'முகவரி சரிபார்க்கப்படுகிறது...',
  'wallet.invalid': 'சரியான வாலட் முகவரியை உள்ளிடவும்',
  'wallet.invalidServer': 'தவறான வாலட் முகவரி',

  // ─── CtaButton ───
  'cta.buy': '{crypto} வாங்கு',
  'cta.sell': '{crypto} விற்கு',
  'cta.gettingPrice': 'சிறந்த விலை தேடப்படுகிறது...',
  'cta.processing': 'செயலாக்கப்படுகிறது...',

  // ─── Footer ───
  'footer.poweredBy': 'இயக்கப்படுகிறது ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'விகித விவரம்',
  'rate.close': 'மூடு',
  'rate.updatesIn': 'விகிதம் 00:{seconds} இல் புதுப்பிக்கப்படும்',
  'rate.noQuote': 'மேற்கோள் எதுவும் இல்லை',
  'rate.exchangeRate': 'மாற்று விகிதம்',
  'rate.processingFee': 'செயலாக்க கட்டணம்',
  'rate.networkFee': 'நெட்வொர்க் கட்டணம்',
  'rate.provider': 'வழங்குநர்',

  // ─── Toast ───
  'toast.orderCreated': 'ஆர்டர் உருவாக்கப்பட்டது',
  'toast.redirecting': 'செக்அவுட்டிற்கு திருப்பி விடப்படுகிறது...',
  'toast.orderFailed': 'ஆர்டர் தோல்வியுற்றது',
  'toast.couldNotCreate': 'ஆர்டர் உருவாக்க முடியவில்லை',
  'toast.quoteError': 'மேற்கோள் பிழை',
  'toast.noProviders': 'வழங்குநர்கள் இல்லை',
  'toast.somethingWrong': 'ஏதோ தவறு நடந்தது',

  // ─── Form errors ───
  'error.amountZero': 'தொகை 0-ஐ விட அதிகமாக இருக்க வேண்டும்',
  'error.minAmountFiat': 'குறைந்தபட்ச தொகை {min} {currency}',
  'error.minAmountCrypto': 'குறைந்தபட்ச தொகை {min} {currency}',
  'error.noProviders': 'இந்த சேர்க்கைக்கு வழங்குநர்கள் எவரும் இல்லை',
  'error.currencyUnavailableBuy': 'இந்த நாணயம் வாங்கல் ஆர்டர்களுக்கு கிடைக்கவில்லை',
  'error.currencyUnavailableSell': 'இந்த நாணயம் விற்பனை ஆர்டர்களுக்கு கிடைக்கவில்லை',

  // ─── Parity banner ───
  'parity.info': 'உங்களிடம் {receiveAmount} {crypto}-க்கு கட்டணம் வசூலிக்கப்படும், மீதமுள்ள {spendAmount} {fiat} வரை உங்கள் {partner} கணக்கில் வரவு வைக்கப்படும்',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'பாதுகாப்பான கட்டணம்',
  'redirect.title': 'கட்டணத்தை தொடரவும்',
  'redirect.description': 'உங்கள் கட்டணத்தை முடிக்க {gateway}-க்கு திருப்பி விடப்படுவீர்கள்.',
  'redirect.countdown': '{seconds} நொடிகளில் திருப்பி விடப்படுகிறது...',
  'redirect.openTab': 'புதிய தாவலில் ACH திறக்கவும்',
  'redirect.cancel': 'ரத்து செய்',

  // ─── Checkout Step ───
  'checkout.noOrder': 'ஆர்டர் எதுவும் கிடைக்கவில்லை',
  'checkout.goBack': 'திரும்பு',
  'checkout.expired': 'செக்அவுட் காலாவதியானது',
  'checkout.expiredDesc': 'அமர்வு காலாவதியானது. மீண்டும் முயற்சிக்கவும்.',
  'checkout.startOver': 'மீண்டும் தொடங்கு',
  'checkout.cancel': 'ரத்து செய்',
  'checkout.loading': 'செக்அவுட் ஏற்றப்படுகிறது...',
  'checkout.iframeTitle': 'வழங்குநர் செக்அவுட்',
  'checkout.widgetTitle': 'கட்டண செக்அவுட்',
  'checkout.unknownMethod': 'தெரியாத செக்அவுட் முறை',

  // ─── Processing Step ───
  'processing.default': 'உங்கள் ஆர்டர் செயலாக்கப்படுகிறது...',
  'processing.pending': 'கட்டண உறுதிப்படுத்தலுக்காக காத்திருக்கிறோம்...',
  'processing.active': 'உங்கள் பரிவர்த்தனை செயலாக்கப்படுகிறது...',
  'processing.generic': 'செயலாக்கப்படுகிறது...',
  'processing.checkingStatus': 'நிலை சரிபார்க்கப்படுகிறது...',
  'processing.orderId': 'ஆர்டர் ஐடி',
  'processing.provider': 'வழங்குநர்',
  'processing.amount': 'தொகை',
  'processing.receiving': 'பெறப்படுகிறது',
  'processing.network': 'நெட்வொர்க்',
  'processing.toAddress': 'பெறும் முகவரி',
  'processing.usuallyMinutes': 'இது பொதுவாக சில நிமிடங்கள் ஆகும்.',
  'processing.safeToClose': 'இந்தப் பக்கத்தை பாதுகாப்பாக மூடலாம் — முடிந்ததும் நாங்கள் உங்களுக்கு மின்னஞ்சல் அனுப்புவோம்.',

  // ─── Complete Step ───
  'complete.buyTitle': 'கொள்முதல் முடிந்தது!',
  'complete.sellTitle': 'விற்பனை முடிந்தது!',
  'complete.buyDesc': 'உங்கள் {crypto} உங்கள் வாலட்டிற்கு அனுப்பப்பட்டது.',
  'complete.sellDesc': 'உங்கள் {fiat} பணம் செயலாக்கப்படுகிறது.',
  'complete.amountBuy': 'பெற்ற தொகை',
  'complete.amountSell': 'விற்ற தொகை',
  'complete.paidBuy': 'செலுத்திய தொகை',
  'complete.paidSell': 'வழங்கப்படும் தொகை',
  'complete.network': 'நெட்வொர்க்',
  'complete.wallet': 'வாலட்',
  'complete.transaction': 'பரிவர்த்தனை',
  'complete.provider': 'வழங்குநர்',
  'complete.orderId': 'ஆர்டர் ஐடி',
  'complete.completed': 'முடிந்தது',
  'complete.viewExplorer': 'எக்ஸ்ப்ளோரரில் பார்க்கவும்',
  'complete.done': 'சரி',

  // ─── Error Step ───
  'errorStep.failed': 'கட்டணம் தோல்வியுற்றது',
  'errorStep.cancelled': 'ஆர்டர் ரத்தானது',
  'errorStep.expired': 'ஆர்டர் காலாவதியானது',
  'errorStep.refunded': 'ஆர்டர் திரும்பப் பெறப்பட்டது',
  'errorStep.unknown': 'ஏதோ தவறு நடந்தது',
  'errorStep.failedBuy': 'உங்கள் கட்டணத்தை செயலாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைப் பயன்படுத்தவும்.',
  'errorStep.failedSell': 'உங்கள் விற்பனையை செயலாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  'errorStep.cancelledBuy': 'உங்கள் ஆர்டர் ரத்தானது. எந்த கட்டணமும் செயலாக்கப்படவில்லை.',
  'errorStep.cancelledSell': 'உங்கள் விற்பனை ரத்தானது. எந்த கிரிப்டோவும் மாற்றப்படவில்லை.',
  'errorStep.expiredBuy': 'உங்கள் ஆர்டர் காலாவதியானது. புதிய கொள்முதலை தொடங்கவும்.',
  'errorStep.expiredSell': 'உங்கள் ஆர்டர் காலாவதியானது. புதிய விற்பனையை தொடங்கவும்.',
  'errorStep.refundedBuy': 'உங்கள் கட்டணம் திரும்பப் பெறப்பட்டது. 5-10 வணிக நாட்களில் தொகை உங்கள் கணக்கில் தெரியும்.',
  'errorStep.refundedSell': 'உங்கள் கிரிப்டோ திரும்பப் பெறப்பட்டது. விரைவில் தொகை உங்கள் வாலட்டில் தெரியும்.',
  'errorStep.genericDesc': 'எதிர்பாராத பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.',
  'errorStep.orderId': 'ஆர்டர் ஐடி',
  'errorStep.tryAgain': 'மீண்டும் முயற்சி செய்',
  'errorStep.startOver': 'மீண்டும் தொடங்கு',
  'errorStep.return': 'திரும்பு',
  'errorStep.needHelp': 'உதவி வேண்டுமா? தொடர்பு கொள்ளவும் ',
  'errorStep.reference': 'குறிப்பு: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'கொள்முதலை உறுதிப்படுத்தவும்',
  'confirm.sellTitle': 'விற்பனையை உறுதிப்படுத்தவும்',
  'confirm.loading': 'ஏற்றப்படுகிறது...',
  'confirm.provider': 'வழங்குநர்',
  'confirm.youPay': 'நீங்கள் செலுத்துகிறீர்கள்',
  'confirm.youSell': 'நீங்கள் விற்கிறீர்கள்',
  'confirm.youReceive': 'நீங்கள் பெறுகிறீர்கள்',
  'confirm.wallet': 'வாலட்',
  'confirm.network': 'நெட்வொர்க்',
  'confirm.refundAddress': 'திரும்ப செலுத்தும் முகவரி',
  'confirm.parityNote': 'வழங்குநரின் கட்டண தொகை மாறுபடலாம். மீதமுள்ள {amount} {crypto} வரை உங்கள் {partner} கணக்கில் வரவு வைக்கப்படும்.',
  'confirm.processing': 'செயலாக்கப்படுகிறது...',
  'confirm.confirmPay': 'உறுதிப்படுத்தி செலுத்து',
  'confirm.confirmSell': 'உறுதிப்படுத்தி விற்கு',
  'confirm.payout': '{currency} பணம்',

  // ─── Modals ───
  'modal.selectFiat': 'ஃபியட் நாணயத்தை தேர்ந்தெடுக்கவும்',
  'modal.selectCrypto': 'கிரிப்டோ நாணயத்தை தேர்ந்தெடுக்கவும்',
  'modal.choosePayment': 'கட்டண முறையை தேர்ந்தெடுக்கவும்',
  'modal.selectCountry': 'உங்கள் நாட்டை தேர்ந்தெடுக்கவும்',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'பிரபலமானவை',
  'modal.recommended': 'பரிந்துரைக்கப்பட்டவை',
  'modal.noCurrencies': 'நாணயங்கள் எதுவும் கிடைக்கவில்லை',
  'modal.noPaymentMethods': 'கட்டண முறைகள் எதுவும் கிடைக்கவில்லை',
  'modal.noCountries': 'நாடுகள் எதுவும் கிடைக்கவில்லை',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'இடம்',
  'settings.darkMode': 'இருண்ட பயன்முறை',
  'settings.privacy': 'தனியுரிமைக் கொள்கை',
  'settings.terms': 'பயன்பாட்டு விதிமுறைகள்',
  'settings.language': 'மொழி',

  // ─── Additional ───
  'modal.chooseRamp': 'Ramp தேர்ந்தெடுக்கவும்',
  'modal.bestPrice': 'சிறந்த விலை',
  'modal.noQuotes': 'இந்த கோரிக்கைக்கு மேற்கோள்கள் எதுவும் இல்லை',
  'modal.noProvidersFound': 'வழங்குநர்கள் எவரும் கிடைக்கவில்லை',
  'payment.unavailableFor': '{currency} க்கு கட்டண முறைகள் எதுவும் இல்லை',
  'skeleton.poweredBy': 'NowRamp ஆல் இயக்கப்படுகிறது',
  'error.createOrderFailed': 'ஆர்டர் உருவாக்க தோல்வியுற்றது',
  'errorStep.returnToMerchant': 'வணிகரிடம் திரும்பவும்',
  'confirm.cryptoOnNetwork': '{crypto} {network}-ல்',
  'payment.name.card': 'கார்டு',
  'payment.name.bankTransfer': 'வங்கி பரிமாற்றம்',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ta;
